import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { OutputSettingsEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class OutputSettingsSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    analogSettingsUpdated$() {
        return this.socketService.receiveMessageObserver(OutputSettingsEvents.ANALOG_SETTINGS_UPDATED);
    }

    digitalSettingsUpdated$() {
        return this.socketService.receiveMessageObserver(OutputSettingsEvents.DIGITAL_SETTING_UPDATED);
    }

    digitalSettingsDeleted$() {
        return this.socketService.receiveMessageObserver(OutputSettingsEvents.DIGITAL_SETTING_DELETED);
    }
}
